import React from "react";

function NoResultView({ category }) {
  return (
    <div className="no-result-wrapper pb-5">
      No results found for{" "}
      {category.type === "active,activenosis"
        ? "Active Funding Opportunities"
        : category.type === "expired,expirednosis"
        ? "Expired Funding Opportunities"
        : category.type === "notices,activenosis"
        ? "Active Notice Items"
        : category.type === "expirednosis"
        ? "Expired Notice Items"
        : "search criteria"}
    </div>
  );
}

export default NoResultView;
